import React from "react";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { PAGE_TITLE_STYLE, SECTION_H2_STYLE } from "../edit/textStyles";

function ExpectationPage() {
  return (
    <div className="main-content" style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <EditableText id="expectation.title" defaultContent="期待" defaultStyle={PAGE_TITLE_STYLE} />
      <section style={{ margin: "32px 0" }}>
        <EditableText id="expectation.growth-title" as="h2" defaultContent="在属灵成长中：" defaultStyle={SECTION_H2_STYLE} />
        <EditableText
          id="expectation.growth-list"
          as="div"
          defaultContent={"1. 在教会中敬虔的敬拜\n2. 在基督的身体中合一、彼此相爱的弟兄姐妹\n3. 忠于圣经的教导\n4. 基于圣经的讲道\n5. 在基督里的丰盛生命\n6. 经历生命的转变，忠心跟随基督\n7. 通过服事本地社区的需要，与本地社区更深的联合"}
          defaultStyle={{ fontSize: "1.1em", lineHeight: 2 }}
        />
      </section>
      <section style={{ margin: "32px 0" }}>
        <EditableText id="expectation.worship-title" as="h2" defaultContent="在敬拜中：" defaultStyle={SECTION_H2_STYLE} />
        <EditableText
          id="expectation.worship-list"
          as="div"
          defaultContent={"1. 欢迎所有人参加\n2. 儿童主日学\n3. 语言：讲道与教导均为中文\n4. 音乐：以符合圣经的方式将我们的赞美献给神"}
          defaultStyle={{ fontSize: "1.1em", lineHeight: 2 }}
        />
      </section>
      <PageCopyright pageId="expectation" />
    </div>
  );
}

export default ExpectationPage;
